import React from "react";
import { sessionPoints } from "../../data/content";
export function SessionSection() {
  return <section aria-labelledby="session-title" className="on-light bg-ice" data-id="element-243" data-mp="3a4m9jpdibotn">
      <div className="container-x grid gap-10 py-14 sm:gap-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-244" data-mp="3p13kwglp53g7">
        <div className="lg:col-span-5" data-id="element-245" data-mp="3k2a4afb44wbt">
          <p className="eyebrow" data-id="element-246" data-mp="3k17c84220nub">In the gym</p>
          <h2 id="session-title" className="section-title mt-4" data-id="element-247" data-mp="1wdx46x4uizl">
            Built around a <span className="text-navy underline decoration-cyan decoration-[4px] underline-offset-[6px]" data-id="element-248" data-mp="1ub0v55dztmf">real school session</span>
          </h2>
          <p className="mt-5 max-w-[30rem] text-[16px] leading-[1.7] text-body sm:mt-6 sm:text-[17px]" data-id="element-249" data-mp="bmgq47497wxx">
            Lessons are planned around the shape of an actual PE period: a defined length, the equipment schools typically have, and room for you to adapt.
          </p>

          <div className="mt-8 max-w-[30rem] sm:mt-10" data-id="element-250" data-mp="gljudpcetz4u">
            <h3 className="sr-only" data-id="element-251" data-mp="gmuvfheh0ss9">Lesson length</h3>
            <div data-id="element-252" data-mp="20t1vipy90jqe">
              <div className="flex items-baseline justify-between text-sm" data-id="element-253" data-mp="20tlem9zmxe60">
                <span className="font-bold uppercase tracking-[0.14em] text-body" data-id="element-254" data-mp="24tlsntitnncj">Planned lesson</span>
                <span className="font-display text-2xl font-bold text-navy" data-id="element-255" data-mp="29soz9iega1mm">45 min</span>
              </div>
              <div className="mt-2 h-3 rounded-full bg-cyan" aria-hidden="true" data-id="element-256" data-mp="2esl3nir27v2p" />
            </div>
            <div className="mt-5" data-id="element-257" data-mp="2js7g3pz2d7ag">
              <div className="flex items-baseline justify-between text-sm" style={{
              width: "88.9%"
            }} data-id="element-258" data-mp="2jr5uirkf92eh">
                <span className="font-bold uppercase tracking-[0.14em] text-body" data-id="element-259" data-mp="2nr6m7dwj7a3h">Adaptation</span>
                <span className="font-display text-2xl font-bold text-navy" data-id="element-260" data-mp="2skhqp8dvfes8">40 min</span>
              </div>
              <div className="mt-2 h-3 rounded-full bg-navy/10" aria-hidden="true" data-id="element-261" data-mp="2xkx2hvii8e83">
                <div className="h-full rounded-full bg-orange" style={{
                width: "88.9%"
              }} data-id="element-262" data-mp="32jqko18qktel" />
              </div>
            </div>
          </div>
        </div>

        <dl className="border-t-2 border-cyan lg:col-span-6 lg:col-start-7 lg:self-end" data-id="element-263" data-mp="2hs1rpti5fjbs">
          {sessionPoints.map(point => <div key={point.title} className="border-b border-navy/10 py-5 sm:py-7" data-id="element-264" data-mp="2cvberf1n53ul">
              <dt className="font-display text-[22px] font-bold uppercase leading-none text-navy sm:text-[28px]" data-id="element-265" data-mp="2rjfymmcfjley">{point.title}</dt>
              <dd className="mt-2 max-w-[36rem] text-[15px] leading-relaxed text-body sm:mt-3 sm:text-base" data-id="element-266" data-mp="2mpuxwmjgcdc2">{point.text}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}